import Tabs from 'src/components/Tabs/Tabs';

import { useWorkspaceSettingsPanel } from './useWorkspaceSettingsPanel';

export const WorkspaceSettingsPanel = ( {
	workspaceID
}: { workspaceID: number } ) => {
	const {
		workspace,
		tabItems,
		selectedTabIndex,
		onTabChanged,
		CurrentTabComponent
	} = useWorkspaceSettingsPanel( workspaceID );

	return (
		<div className="workspace-settings-panel">
			<div className="header">
				<Tabs
					tabSelected={selectedTabIndex}
					tabs={tabItems}
					onTabChange={onTabChanged}
				/>
			</div>
			<div className="body">
				<CurrentTabComponent workspaceID={workspace.id} />
			</div>
		</div>
	);
};

export default WorkspaceSettingsPanel;
